var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      attrs: {
        drag: "",
        action: "#",
        "file-list": _vm.fileList,
        multiple: _vm.multiple,
        "on-success": _vm.uploadSuccess,
        "http-request": _vm.httpUpload,
      },
      scopedSlots: _vm._u([
        {
          key: "tip",
          fn: function () {
            return [
              _c("div", { staticClass: "el-upload__tip" }, [
                _vm._v(
                  "\n      文件后缀名必须为xls或xlsx(即Excel格式)文件大小不得大于10M\n    "
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-icon",
        { staticClass: "el-icon--upload" },
        [_c("upload-filled")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "el-upload__text" }, [
        _vm._v("\n    将文件拖到此处，或"),
        _c("em", [_vm._v("点击上传")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }